import React from 'react'
import { Text } from '../../common'

const OrderCardDelivery = () => {
  return {
    title: <Text strong text='Despacho' />,
    info: [
      // { title: 'Mail', value: () => 'mail@mail.com' },
      // { title: 'RUT', value: () => '12.123.456-7' },
      // { title: 'Dirección', value: () => 'long adress' },
      // { title: 'Dirección', value: () => 'long adress' }
    ]
  }
}

export default OrderCardDelivery
